import { useIntl } from 'react-intl';
import { ChangeEvent, useState, useCallback, useEffect, useRef } from 'react';
import NoContent from '../../components/UIelements/NoContent';
import PrimaryButton from '../../components/FormElements/PrimaryButton';
import { Company, LoggedUser, UserConfigs } from '../../db/db';
import * as Styled from './styles';
import SearchBar from '../../components/UIelements/SearchBar';
import ModalAddSerialNumber from '../../components/Modals/ModalAddSerialNumber';
import { MdLocationOn } from 'react-icons/md';
import Map from "../../components/UIelements/Map";
import Header from '../../components/UIelements/Header';
import { AiOutlineLeft } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router-dom';
import useDebounce from '../../hooks/useDebounce';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { loadSerialNumbers } from '../../services';
import TableSerialNumbers from './tableSerialNumber';
import Loading from '../../components/Loading';
import { Pagination } from '@material-ui/lab';
import ModalDeleteSerialNumber from '../../components/Modals/ModalDeleteSerialNumber';
import ModalEditSerialNumber from '../../components/Modals/ModalEditSerialNumber';
import { FLAG_NUMBER } from 'html2canvas/dist/types/css/syntax/tokenizer';

type UserTabProps = {
  user?: LoggedUser[];
  company?: Company[];
  userConfigs?: UserConfigs[];
};

const SerialNumbers = (props: UserTabProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { idCompany } = useParams();
  const globalUser = useSelector((state: RootState) => state.user.object);
  const globalCompanies = useSelector((state: RootState) => state.companies);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showMap, setShowMap] = useState(false);
  const [serialNumbers, setSerialNumbers] = useState<any[]>([]);
  const [selectSerialNumber, setSelectSerialNumber] = useState<number>();
  const [selectedMarkerList, setSelectedMarkerList] = useState<Array<number>>([]);

  const [showModalAddSerialNumber, setShowModalAddSerialNumber] = useState(false);
  const [showModalDeleteSerialNumber, setShowModalDeleteSerialNumber] = useState(false);
  const [showModalUpdateSerialNumber, setShowModalUpdateSerialNumber] = useState(false);

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalOpenPage, setTotalOpenPage] = useState<number>(0);
  const [limitDataToFetch, setLimitDataToFetch] = useState<number>(12);

  const [searchValue, setSearchValue] = useState<string>('');
  const debouncedSearchTerm = useDebounce(searchValue, 1000);



  const fetchSerialNumbers = async (page: number, search: string = '') => {
    setIsLoading(true);
    try {
      const resp = await loadSerialNumbers(idCompany!, globalUser?.user.accessToken ?? '', limitDataToFetch, page, search);
      setSerialNumbers(resp.data.SerialNumbers);
      setTotalOpenPage(Math.ceil(resp.data.totalCount / limitDataToFetch));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSerialNumbers(pageNumber, searchValue);
  }, [pageNumber, limitDataToFetch]);

  useEffect(() => {
    fetchSerialNumbers(1, debouncedSearchTerm);
  }, [debouncedSearchTerm, limitDataToFetch]);


  /* 
    const openMap = useCallback(() => {
      setShowMap(true);
    }, []);
  
    const closeMap = useCallback(() => {
      setShowMap(false);
    }, []); */

  const handleSearchValue = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setSearchValue(event.target.value);
    },
    []
  );

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    if (newPage !== pageNumber) {
      setPageNumber(newPage);
    }
  };

  const divContentRef = useRef<HTMLDivElement>(null);

  const calculateLimitByDivSize = (): number => {
    if (!divContentRef.current) return 12;
    const tableHeight = divContentRef.current.clientHeight;
    let lineHeight = 46;
    let discountHeight = 160
    if (window.innerWidth <= 960) {
      lineHeight = 70;
      discountHeight = 170
    }
    const visibleRows = Math.floor((tableHeight - discountHeight) / lineHeight)
    setLimitDataToFetch(visibleRows > 0 ? visibleRows : 12)
    return visibleRows > 0 ? visibleRows : 12
  };

  useEffect(() => {
    const handleResize = () => calculateLimitByDivSize();
    window.addEventListener('resize', handleResize);

    const limitData = calculateLimitByDivSize();
    setLimitDataToFetch(limitData)
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {showModalAddSerialNumber && (
        <div className="modal">
          <ModalAddSerialNumber
            idCompany={idCompany!}
            onCancel={() => setShowModalAddSerialNumber(false)}
            refresh={() => fetchSerialNumbers(pageNumber)}
          />
        </div>
      )}

      {showModalDeleteSerialNumber && (
        <div className="modal">
          <ModalDeleteSerialNumber
            onCancel={() => setShowModalDeleteSerialNumber(false)}
            refresh={() => fetchSerialNumbers(pageNumber)}
            selectSerialNumber={selectedMarkerList.length ? selectedMarkerList : [selectSerialNumber ?? 0]}
          />
        </div>
      )}

      {showModalUpdateSerialNumber && (
        <div className="modal">
          <ModalEditSerialNumber
            onCancel={() => setShowModalUpdateSerialNumber(false)}
            refresh={() => fetchSerialNumbers(pageNumber)}
            selectSerialNumber={selectSerialNumber ?? 0}
            serialNumbers={serialNumbers.find((e: any) => e.id === selectSerialNumber)}
          />
        </div>
      )}

      {/*showMap && (
        <Map
          markerList={equipmentAddress()}
          onClose={closeMap}
          language={'PT'}
          localization={localizationEquipment}
        />
      )*/}

      <Header className='headerPage' hideItem='SELECTIONS'>
        <Styled.ArrowBack onClick={() => (navigate("/companies"))}>
          <AiOutlineLeft />
          {intl.formatMessage({ id: "menus.VOLTAR" })}
        </Styled.ArrowBack>
      </Header>
      <Styled.Header>
        <Styled.CompanyName>
          {globalCompanies.companies?.corporateName ?? ''}
        </Styled.CompanyName>

        <Styled.Location>
          <Styled.Country>{intl.formatMessage({ id: 'equipment.país' }) + ': '}<div>{globalCompanies.companies?.location}</div></Styled.Country>
          {/* <Styled.Map onClick={openMap}>  <MdLocationOn />{intl.formatMessage({ id: 'menus.ver localização' })}</Styled.Map> */}
        </Styled.Location>

        <Styled.EquipmentManager>
          <Styled.InputDiv>
            <SearchBar
              value={searchValue}
              onChange={handleSearchValue}
              placeholder={intl.formatMessage({
                id: `${window.innerWidth > 960 ? 'equipment.Procurar número de série' : 'main.Procurar'}`
              })}
            />
          </Styled.InputDiv>

          <Styled.ButtonsDiv>
            <PrimaryButton
              model='confirmation-gradient'
              type='button'
              size='extra-large'
              width='168px'
              onClick={() => {
                setShowModalAddSerialNumber(true);
              }}
            >
              {intl.formatMessage({ id: 'equipment.adicionar equipamento' }).toUpperCase()}
            </PrimaryButton>
          </Styled.ButtonsDiv>
          <Styled.ButtonsDiv id='user-tab__mobile-button'>
            <PrimaryButton
              model='confirmation-gradient'
              type='button'
              size='medium'
              width='112px'
              onClick={() => setShowModalAddSerialNumber(true)}
            >
              {intl.formatMessage({ id: 'company.Adicionar' }).toUpperCase()}
            </PrimaryButton>
          </Styled.ButtonsDiv>
        </Styled.EquipmentManager>
      </Styled.Header >

      <Styled.Content ref={divContentRef}>
        {isLoading && <Loading />}
        {!isLoading && (
          !serialNumbers.length ?
            <NoContent>
              {intl.formatMessage({ id: 'company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(' })}
            </NoContent>
            :
            <>
              <Styled.TableContent>
                <TableSerialNumbers
                  serialNumbers={serialNumbers}
                  selectSerialNumber={setSelectSerialNumber}
                  showModalDeleteSerialNumber={() => setShowModalDeleteSerialNumber(true)}
                  showModalUpdateSerialNUmber={() => setShowModalUpdateSerialNumber(true)}
                  selectedMarker={setSelectedMarkerList}
                  serialNumberCheck={selectedMarkerList}
                  idCompany={idCompany!}
                  accessToken={globalUser?.user.accessToken ?? ''} />
              </Styled.TableContent>
              {!selectedMarkerList.length &&
                <Styled.PaginationDiv>
                  <Pagination page={pageNumber} onChange={handleChangePage} count={totalOpenPage} />
                </Styled.PaginationDiv>
              }
            </>
        )}
      </Styled.Content>

    </>
  );
};

export default SerialNumbers;
